import { ReactNode } from 'react';
import ModalLoadingBackdrop from './ModalLoadingBackdrop';

interface IProps {
  children: ReactNode;
  backdropOpen?: boolean;
}

const LoadingBackdropWrapper = ({ children, backdropOpen }: IProps) => {
  return (
    <>
      {children}
      <ModalLoadingBackdrop open={backdropOpen} />
    </>
  );
};

export default LoadingBackdropWrapper;
